import { resetAllSelectedStores } from "../selected/resetAllSelected";
import { countdownApi } from "./countdown";
import { stepsApi } from "../../steps/stepsStore";
import { LocationsEndpoint } from "../endpoints/locations";
import { PersonTypesEndpoint } from "../endpoints/personTypes";
import { PackagesEndpoint } from "../endpoints/packages";
import { ActivitiesEndpoint } from "../endpoints/activities";

export const endSession = async (): Promise<void> => {
  LocationsEndpoint.list.store.reset();
  PersonTypesEndpoint.list.store.reset();
  PackagesEndpoint.list.store.reset();
  ActivitiesEndpoint.list.store.reset();

  countdownApi.stop();
  stepsApi.reset(undefined);
  resetAllSelectedStores();
};
